import { ICartItem } from "../../Interfaces/Cart";

const icon = document.querySelector<HTMLAnchorElement>("body > header > .header-icon.shopping-cart");
const updateIndicator = function (e: CustomEvent) {
    if (icon && e.detail.item_count) {
        icon.dataset.itemCount = getItemCountWithoutServices(e.detail.items);
    } else {
        delete icon.dataset.itemCount;
    }
};

const getItemCountWithoutServices = (items: ICartItem[]): string =>
    // Don't count hidden products in the indicator
    items.filter((item) => !item.handle.startsWith("_")).length.toString();

window.addEventListener("cart-change", updateIndicator);
window.addEventListener("cart-add-success", updateIndicator);
